import { Component, Input } from '@angular/core';
import { CustomSeoContentGuide } from '~app/modules/custom-hub/models/custom-seo-content.model';
import { ApplicationEventService } from '~shared/modules/application-event/services';
import { SeoFaqToggleApplicationEvent } from '~shared/modules/application-event/models/seo-faq-toggle-event.model';
import { SeoFaqToggleType } from '../../constants';
import { PageDetectionUtil } from '~shared/utils/page-detection.util';
import { NavigationHelper } from '~shared/services/navigation-helper.service';

@Component({
  selector: 'app-seo-faq-content',
  templateUrl: './seo-faq-content.component.html',
  styleUrls: ['./seo-faq-content.component.scss'],
})
export class SeoFaqContentComponent {
  @Input() faqTitle: string;
  @Input() faqContent: CustomSeoContentGuide[];

  currentUrl = this.navigationHelper.getCurrentUrl();

  get isContentLandingPage(): boolean {
    return PageDetectionUtil.isLandingPagePage(this.currentUrl);
  }

  constructor(private applicationEventService: ApplicationEventService, private navigationHelper: NavigationHelper) {}

  toggleOpen(isOpen: boolean): void {
    this.applicationEventService.publish(
      new SeoFaqToggleApplicationEvent(isOpen ? SeoFaqToggleType.FaqOpen : SeoFaqToggleType.FaqClose)
    );
  }
}
